// extracted by mini-css-extract-plugin
export default {"slide_container":"TaskSlide_slide_container__PeEcv","next_btn_wrapper":"TaskSlide_next_btn_wrapper__RQ+aH"};